import { gqlSubmissionStatusEnum as SUBMISSION_STATUS } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';

export const useSubmissionStatusOptions = () => {
  const { t } = useTranslation();

  return [
    { value: SUBMISSION_STATUS.TO_REVIEW, label: t('common:label.unviewed') },
    { value: SUBMISSION_STATUS.REVIEWED, label: t('common:label.viewed') },
    { value: SUBMISSION_STATUS.SELECTED, label: t('common:label.selected') },
    { value: SUBMISSION_STATUS.UNDER_CONSIDERATION, label: t('common:form.label.underConsideration') },
    { value: SUBMISSION_STATUS.ON_AVAIL, label: t('common:label.onAvail') },
    { value: SUBMISSION_STATUS.BOOKED, label: t('common:label.booked') },
  ];
};
